import { render, staticRenderFns } from "./addreplenishment.vue?vue&type=template&id=03144d34&scoped=true&"
import script from "./addreplenishment.vue?vue&type=script&lang=js&"
export * from "./addreplenishment.vue?vue&type=script&lang=js&"
import style0 from "./addreplenishment.vue?vue&type=style&index=0&id=03144d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03144d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03144d34')) {
      api.createRecord('03144d34', component.options)
    } else {
      api.reload('03144d34', component.options)
    }
    module.hot.accept("./addreplenishment.vue?vue&type=template&id=03144d34&scoped=true&", function () {
      api.rerender('03144d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/topup/components/addreplenishment.vue"
export default component.exports